var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Login vs Logout"}},[_c('div',{staticClass:"chart-area-container"},[_c('app-echart-stacked-area',{style:({ width: '100%' ,height:'300px'}),attrs:{"option-data":_vm.option}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }